<template>

  <modal-layout
    :bgShow="scorring_popup.show"
    :modalShow="scorring_popup.show"
    @close="close">

    <div
      class="scorring-modal">
      <div
        class="scorring-modal__head">
          Подтверждение состояния устройства
      </div>
      <div class="scorring-modal__body">
        <div v-if="isTelegramFlow && (scorring==1 || scorring==2 || scorring==6)" class="text">
          <p>Перейдите в Telegram (@tkitradein_bot) для подтверждения</p>
          <qr-code :size="qrSize" :errorLevel="'L'" class="qr" :text="telegramScoringLink"></qr-code>
          <p><a target="_blank" :href="telegramScoringLink">{{ telegramScoringLink }}</a></p>
        </div>
        <div v-else-if="hasInvalidScoringFlow" class="scorring-modal__status scorring-modal__status--error">
          Неизвестный тип подтверждения. Обратитесь в техническую поддержку.
        </div>
        <div v-else-if="configLoading" class="scorring-modal__status">
          Загружаем настройки scoring...
        </div>
        <div v-else-if="configError" class="scorring-modal__status scorring-modal__status--error">
          {{ configError }}
        </div>
        <div v-else-if="isPageFlow && scoringIsActive" class="text">
          <label v-if="isPhotoAssessment && showPreliminaryCheckbox && scorring!=6" class="checkbox-container">
            Предварительная оценка
            <input type="checkbox" v-model="preliminaryValue">
            <span class="checkmark"></span>
          </label>
          <p v-if="isPhotoAssessment && scorring==6" class="scorring-modal__note">Предварительная оценка получена. Для завершения необходимо получить финальную оценку.</p>
          <p v-if="isVideoAssessment" class="scorring-modal__note">Требуется дополнительная видеопроверка устройства перед завершением выкупа.</p>
          <p v-if="isVideoAssessment">Считайте QR-код устройством, с помощью которого будет проводиться видеопроверка, или перейдите по ссылке <a target="_blank" :href="photoScoringLink">Начать видеопроверку</a>.</p>
          <p v-else>Для подтверждения заявки считайте QR-код другим устройством, с помощью которого вы будете делать фотографии сдаваемого устройства или перейдите по ссылке <a target="_blank" :href="photoScoringLink">{{ finalAssessment ? 'Получить финальную оценку' : 'Начать проверку' }}</a></p>
          <qr-code :size="qrSize" :errorLevel="'L'" class="qr" :text="photoScoringLink"></qr-code>
          <div v-if="hasScoringUrlOptions" class="scorring-modal__url-options">
            <button
              v-for="(option, index) in scoringUrlOptions"
              :key="`${option.type}-${option.url}-${index}`"
              type="button"
              class="scorring-modal__url-option"
              :class="{ active: selectedScoringUrlIndex === index }"
              @click.prevent="selectScoringUrl(index)">
              {{ option.label }}
            </button>
          </div>
          <button
            v-if="isPhotoAssessment && scorring==6 && !finalAssessment"
            type="button"
            class="btn next"
            @click.prevent="requestFinalAssessment()">
            Получить финальную оценку
          </button>
        </div>
        <div v-if="scorring==3">
          Состояние устройство подтверждено, можете продолжить оценку
        </div>
        <div v-if="scorring==4">
          Устройство не прошло проверку на состояние, проведите оценку устройства повторно и внимательно отвечайте на вопросы
        </div>
      </div>
      <div
        class="scorring-modal__footer">
        <button
          class="btn cancel"
          @click.prevent="send()">
          Закрыть
        </button>
      </div>
    </div>
  </modal-layout>
  
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import ModalLayout from './ModalLayout';

export default {
  components: {
    ModalLayout,
  },
  data() {
    return {
      selectedScoringUrlIndex: 0,
      configLoading: false,
      configError: '',
      openedAssessment: null,
    }
  },
  computed: {
    ...mapState('buyphones', ['scorring','scorring_popup','model', 'questions', 'answers', 'error', 'verifyType', 'preliminary', 'finalAssessment', 'assessment']),
    ...mapState('user', ['user']),
    isTelegramFlow() {
      return this.verifyType === 'tg';
    },
    isPageFlow() {
      return this.verifyType === 'page';
    },
    currentAssessment() {
      return this.openedAssessment || this.assessment;
    },
    isPhotoAssessment() {
      return !this.currentAssessment || this.currentAssessment.type === 'photo';
    },
    isVideoAssessment() {
      return this.currentAssessment && this.currentAssessment.type === 'video';
    },
    scoringIsActive() {
      return !!this.currentAssessment || [1, 2, 6].includes(Number(this.scorring));
    },
    hasInvalidScoringFlow() {
      return this.scoringIsActive && !this.isTelegramFlow && !this.isPageFlow;
    },
    telegramScoringLink() {
      return `https://t.me/tkitradein_bot?start=${this.model?.btag || ''}`;
    },
    preliminaryValue: {
      get() {
        return this.preliminary;
      },
      set(value) {
        this.SET_PRELIMINARY(value);
      }
    },
    showPreliminaryCheckbox() {
      return this.user?.preliminaryCheckEnabled === true;
    },
    scoringUrlOptions() {
      return (this.$config?.domains || []).map(item => ({
        label: item.name,
        url: item.domain,
        type: item.type,
      }));
    },
    hasScoringUrlOptions() {
      return this.scoringUrlOptions.length > 1;
    },
    selectedScoringUrl() {
      const selectedOption = this.scoringUrlOptions[this.selectedScoringUrlIndex] || this.scoringUrlOptions[0];
      return selectedOption ? selectedOption.url : '';
    },
    photoScoringLink() {
      if (!this.selectedScoringUrl) {
        return '';
      }

      if (!this.model?.btag) {
        return `${this.selectedScoringUrl}/`;
      }

      const params = new URLSearchParams({
        contract: this.model.btag,
        token: '1',
      });

      if (this.currentAssessment && this.currentAssessment.id && this.currentAssessment.type) {
        params.set('assessmentId', this.currentAssessment.id);
        params.set('assessmentType', this.currentAssessment.type);
      }

      if (this.preliminary || this.finalAssessment) {
        params.set('preliminary', '1');
      }

      if (this.finalAssessment) {
        params.set('finalAssessment', '1');
      }

      return `${this.selectedScoringUrl}/?${params.toString()}`;
    },
    qrSize() {
      // Адаптивный размер QR-кода в зависимости от размера экрана
      if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        if (screenWidth < 480) {
          return 200; // Мобильные устройства
        } else if (screenWidth < 768) {
          return 300; // Планшеты
        } else {
          return 400; // Десктоп
        }
      }
      return 300; // Значение по умолчанию
    }
  },
  watch: {
    async 'scorring_popup.show'(show) {
      if (!show) {
        this.resetScoringUrlSelection();
        this.configLoading = false;
        this.configError = '';
        this.openedAssessment = null;
        return;
      }

      this.openedAssessment = this.assessment ? { ...this.assessment } : null;
      this.resetScoringUrlSelection();
      await this.ensureScoringConfig();
    },
    assessment(value) {
      if (
        this.scorring_popup.show &&
        value &&
        value.type === 'photo' &&
        (!this.openedAssessment || this.openedAssessment.type === 'photo')
      ) {
        this.openedAssessment = { ...value };
      }
    },
  },
  methods: {
    ...mapActions('buyphones', ['showScorringPopup','closeScorringPopup','getCalc']),
    ...mapMutations('buyphones', ['SET_ERROR', 'SET_PRELIMINARY', 'SET_FINAL_ASSESSMENT']),
    ...mapMutations('user', { logoutUser: 'USER_LOGOUT' }),
    async ensureScoringConfig() {
      if (!this.isPageFlow || !this.scoringIsActive) {
        return;
      }

      this.configLoading = true;
      this.configError = '';

      try {
        await this.$config.load({ attempts: 1, force: true });
        this.resetScoringUrlSelection();

        if (!this.scoringUrlOptions.length) {
          throw new Error('Scoring config is empty');
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.logoutUser();
          this.closeScorringPopup();
          if (this.$route.name !== 'login') {
            this.$router.push({ name: 'login' });
          }
          return;
        }

        this.configError = 'Не удалось загрузить настройки scoring. Обратитесь в техническую поддержку.';
      } finally {
        this.configLoading = false;
      }
    },
    selectScoringUrl(index) {
      this.selectedScoringUrlIndex = index;
    },
    resetScoringUrlSelection() {
      const defaultIndex = this.scoringUrlOptions.findIndex(option => option.type === 'default');
      this.selectedScoringUrlIndex = defaultIndex >= 0 ? defaultIndex : 0;
    },
    requestFinalAssessment() {
      this.SET_FINAL_ASSESSMENT(true);
    },
    close() {
      this.resetScoringUrlSelection()
      this.closeScorringPopup()
    },

    send() {
      // this.getCalc({
      //   btag: this.model.btag,
      //   questions: this.answers,
      // })
      this.resetScoringUrlSelection()
      this.closeScorringPopup()
    },
  },
}
</script>

<style lang="sass">
  @import '@/styles/components/modals/scorring-modal.sass'
</style>
